<template>
  <div class="page-activate-list" :style="{'padding-top': webWithoutNavigation ? '42px' : 0}">
    <div class="activate-lists" v-if="list.length || !loadAll">
      <div class="activate-item" v-for="(t, i) in list" :key="i">
        <!--        <div class="pay-time">支付成功时间：yyyy-mm-dd hh:mm</div>-->
        <div class="course-msg">
          <div class="cover">
            <img :src="t.cover || coverDefault" alt="">
          </div>
          <div class="name-btn">
            <p class="name two-lines">{{t.name}}</p>
            <div class="btn-wrap">
              <button class="btn-activate" @click="activate({courseId: t.id}, actSucc)">激活课程</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>暂无数据</div>
  </div>
</template>

<script>
import storeMixin from '../mixins/store'
import {coverDefault} from './config'
import activateMixin from './activate-mixin'
import csMixins from './cs-mixins'

export default {
  name: 'activate-list',
  mixins: [storeMixin, activateMixin, csMixins],
  data () {
    return {
      coverDefault,
      list: [],
      loadAll: false
    }
  },
  watch: {
    loginCount: {
      immediate: true,
      handler: function (v) {
        if (v > 0) {
          if (this.isWechat && !this.USERINFO.isTourist) {
            this.checkCenterUserInfo()
          }
          this.getList()
          this.SET_PAGE_TITLE('可激活课程列表')
        }
      }
    }
  },
  methods: {
    async getList () {
      try {
        const {data: {code, data, message}} = await this.$rootApi.api(['unActivatedList'])
        if (code === 0) {
          Object.assign(this, {
            loadAll: true,
            list: data.list
          })
        } else {
          throw message
        }
      } catch (e) {
        this.$toast(e.message || e)
      }
    },
    actSucc ({courseId: id}) {
      this.$toast('课程激活成功')
      this.$router.push({name: 'course', params: {id}})
    }
  }
}
</script>

<style lang="stylus" scoped>
.activate-item
  padding .12rem 0
  border-bottom .01rem #E6E6E6 solid
  /*.pay-time*/
  /*  font-size .12rem*/
  /*  line-height 1*/
  /*  color #999*/
  .course-msg
    display flex
    .cover
      width 1.35rem
      > img
        display block
        width 100%
        height .76rem
        object-fit cover
        border-radius .03rem
    .name-btn
      flex 1
      margin-left .1rem
      .name
        height .42rem
        padding .01rem 0
        line-height .21rem
        font-size .15rem
        color #1A1A1A
        font-weight bolder
      .btn-wrap
        margin-top .08rem
        .btn-activate
          float right
          width .8rem
          height .24rem
          border-radius .12rem
          background #FFD500
          font-size .12rem
          color #333
          line-height 1
.no-data
  padding .3rem 0
  text-align center
  line-height 1
  font-size .14rem
  color #999
.activate-lists
  padding 0 .15rem .5rem
</style>
